import Vue from 'vue'
import { somenteNumeros } from './global'
Vue.directive('mascara-cep', {
    inserted: function (el) {
        const limite = 10
        el.maxLength = limite
        el.addEventListener('keypress', function( e ) {
            return somenteNumeros(e) 
        }, true)
        el.addEventListener('focus', function() {
            el.setAttribute('placeholder', '_____-___')
        }, true)
        el.addEventListener('blur', function() {
            el.setAttribute('placeholder', '')
        }, true)
        el.addEventListener('keyup', function(e) {
            let tecla = e.keyCode;
            let vr = e.target.value;
            vr = vr.replace(/[-.]/g, '')
            let tam = vr.length + 1
            if (tecla != 9 && tecla != 8)
            {
                if (tam > 5)
                {
                    e.target.value = vr.substr(0, 5) + '-' + vr.substr(5, 3)
                }
            }
            if(e.target.value.length >= limite){
                let txt = e.target.value.substring(0, limite)
                e.target.value = txt
            }
        }, true)
    }
})